import { useDispatch, useSelector } from 'react-redux'
import { bottomDrawerSelectors, bottomDrawerSlice } from './bottom-drawer.slice'
import type { OpenBottomDrawerPayload } from './bottom-drawer.slice'

export const bottomDrawerHooks = {
  useIsOpen: () => useSelector(bottomDrawerSelectors.getIsOpen),
  useSubscriptionWorkflow: () => useSelector(bottomDrawerSelectors.getSubscriptionWorkflow),

  useBottomDrawerActions: () => {
    const dispatch = useDispatch()

    return {
      openBottomDrawer: (payload: OpenBottomDrawerPayload = {}) => {
        dispatch(bottomDrawerSlice.actions.openBottomDrawer(payload))
      },
      closeBottomDrawer: () => {
        dispatch(bottomDrawerSlice.actions.closeBottomDrawer())
      },
    }
  },
}
